import { FC, InputHTMLAttributes, ReactElement } from 'react';

import classNames from 'classnames';

import { Picture } from '../../../components';
import { FormImageOption } from '../../../entities/@forms/Form/Form';

import './Radio.scss';

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    option: FormImageOption;
    selected: string;
    className?: string;
}

export const Radio: FC<RadioProps> = ({
    option,
    selected,
    disabled,
    className = '',
    ...inputProps
}): ReactElement => {
    const radioClassNames = classNames('radio', {
        'radio--is-checked': option.value === selected,
        'radio--is-disabled': disabled,
    }, className);

    return (
        <label className={radioClassNames}>
            <input
                {...inputProps}
                type="radio"
                value={option.value}
                checked={option.value === selected}
                disabled={disabled}
                className="radio__input"
            />

            <div className="radio__box" />

            {option.image && (
                <Picture
                    {...option.image}
                    className="radio__image"
                />
            )}

            <span className="radio__label">
                {option.label}
            </span>
        </label>
    );
};
